module.exports = __webpack_public_path__ + "img/icon_portfolio-white.9ec6e52.svg";